import React from 'react';

const WindowsIcon = () => {
  return (
    (<svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="WindowsIcon">
      <path
        d="M0.75 2.19608L5.05325 1.60342V5.76083H0.75V2.19667V2.19608ZM0.75 9.80392L5.05325 10.3972V6.2905H0.75V9.80392ZM5.52633 10.4602L11.25 11.25V6.2905H5.52633V10.4602ZM5.52633 1.53983V5.76083H11.25V0.75L5.52633 1.53983Z"
        fill="var(--primaryText)"
      />
    </svg>)
  );
};

export default WindowsIcon;
